import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { selectAll as selectDeclinedReasons } from './+state/declined-reasons/declined-reasons.interfaces';
import { selectEntities as selectRates } from './+state/service-group-rates/service-group-rate.interfaces';
// eslint-disable-next-line max-len
import { selectEntities as selectServiceGroups } from './+state/service-groups/service-groups.interfaces';
import { selectEntities as selectServices } from './+state/services/services.interfaces';
import { combineLatest } from 'rxjs';
import { filter } from 'rxjs/operators';
@Injectable()
export class LabourOperationsStateService {
  constructor(private store: Store<any>) {}

  getServiceGroupData() {
    return combineLatest(this.getServiceGroups(), this.getServices(), this.getServiceGroupRates());
  }

  selectDeclinedReasons() {
    return this.store.pipe(
      select(selectDeclinedReasons),
      filter((declinedReasons: any) => {
        return !this.isEmpty(declinedReasons);
      })
    );
  }
  getServices() {
    return this.store.pipe(
      select(selectServices),
      filter((services: any) => {
        return services;
        //return !this.isEmpty(services);
      })
    );
  }

  getServiceGroupRates() {
    return this.store.pipe(
      select(selectRates),
      filter((rates: any) => {
        return rates;
        //return !this.isEmpty(rates);
      })
    );
  }

  getServiceGroups() {
    return this.store.pipe(
      select(selectServiceGroups),
      filter((serviceGroups: any) => {
        return serviceGroups;
        //return !this.isEmpty(serviceGroups);
      })
    );
  }

  isEmpty(obj: any) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }
}
